<div *ngIf="checking || authService.licenseExpired" class="expired">
    <h1>License Expired</h1>
    Please contact support.<br><br>

    <a (click)="refresh()"><i class="fa fa-refresh" [ngClass]="{'fa-spin': checking}"></i> Recheck</a>
</div>
